module.exports = ".list-group-item {\n  font-size: 12px;\n  cursor: pointer; }\n\na {\n  cursor: pointer; }\n\n.save-btn {\n  margin: 30px 65px; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/app-widgets/app-widgets.component.scss
// module id = ./src/app/components/app-widgets/app-widgets.component.scss
// module chunks = main